import { LocalAtm, Edit } from "@material-ui/icons";

const menu = () => {
  return [
    { label: "Tela Inicial", icon: "pi pi-home", to: "/" },
    { label: "Crédito Salarial", iconMaterial: <LocalAtm />, to: "/manterObrigacao" },
    { label: "Certidões de Crédito", iconMaterial: <LocalAtm />, to: "/certidoesAtivas" },
    { label: "Validação", iconMaterial: <LocalAtm />, to: "/listaCertidao" },
    {
      label: "Tabelas",
      iconMaterial: <Edit />,
      items: [
        { label: "Amparo Legal", icon: "pi pi-circle-on", to: "/manterAmparoLegal" },
        { label: "Pessoa Jurídica", icon: "pi pi-circle-on", to: "/manterEmpresa" },
        // { label: "Tipo Ato", icon: "pi pi-circle-on", to: "/cadastroTipoAto" },
        { label: "Tipo de Certidão", icon: "pi pi-circle-on", to: "/manterTipoCertidao" },
      ],
    },
    // {
    //   label: "Segurança",
    //   icon: "pi pi-briefcase",
    //   items: [
    //     { label: "Usuário", icon: "pi pi-circle-on", to: "/usuario" },
    //     { label: "Perfis", icon: "pi pi-circle-on", to: "/perfilSeguranca" },
    //     {
    //       label: "Auditoria",
    //       icon: "pi pi-circle-on",
    //       items: [
    //         { label: "Pessoa Jurídica", icon: "pi pi-circle-on", to: "/audit/empresa" },
    //         { label: "Obrigação", icon: "pi pi-circle-on", to: "/audit/obrigacao" },
    //         { label: "Amparo Legal", icon: "pi pi-circle-on", to: "/audit/amparoLegal" },
    //         { label: "Tipo de Certidão", icon: "pi pi-circle-on", to: "/audit/tipoCertidao" },
    //         { label: "Tipo Valida Certidão Legada", icon: "pi pi-circle-on", to: "/audit/validaCertidaoLegada" },
    //       ],
    //     },
    //   ],
    // },
    // {
    //   label: "Consulta",
    //   icon: "pi pi-search",
    //   items: [
    //     { label: "Certidões Legadas", icon: "pi pi-circle-on", to: "/certidoesLegadas" },
    //     { label: "Logs de Auditoria", icon: "pi pi-circle-on", to: "/AuditoriaLogs" },
    //   ],
    // },
    {
      label: "Legado",
      iconMaterial: <LocalAtm />,
      items: [{ label: "Seplag", icon: "pi pi-circle-on", to: "/certidoesLegadas" }],
    },
  ];
};

export default menu;

// const IconMaterial = (props) => {
//   return (
//     <span className="material-icons" style={{ marginLeft: 0, fontSize: "16px" }}>
//       {props.nameIcon}
//     </span>
//   );
// };
